module.exports = __webpack_public_path__ + "img/lg_ring_skip_skip_1_1.c365c0c4.png";